import { render, staticRenderFns } from "./FullLayout.vue?vue&type=template&id=761506b4&"
import script from "./FullLayout.vue?vue&type=script&lang=js&"
export * from "./FullLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports